import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// ---- PWA Service Worker registration ----
// Register only in production builds (CRA defines NODE_ENV automatically).
// The SW caches the static app shell for offline / flaky-Wi-Fi resilience.
// In dev (yarn start), we explicitly UNREGISTER any stale SW so HMR works.
if ("serviceWorker" in navigator) {
  if (process.env.NODE_ENV === "production") {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/service-worker.js")
        .then((reg) => {
          // Force the SW to check for a new version on every page load so
          // deploys roll out silently within one refresh instead of
          // waiting for the browser's default 24h update check.
          reg.update().catch(() => {});
          // When a new SW takes control, reload once so the tab picks up
          // the new HTML that references the new JS bundles.
          let refreshing = false;
          navigator.serviceWorker.addEventListener("controllerchange", () => {
            if (refreshing) return;
            refreshing = true;
            window.location.reload();
          });
        })
        .catch((err) => console.warn("SW registration failed:", err));
    });
  } else {
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((r) => r.unregister());
    });
  }
}

